import React from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { Editor, OnMount } from '@monaco-editor/react';

interface EmailTemplateEditorProps {
  reactSourceCode: string;
  htmlTemplate: string;
  onReactCodeChange?: (value: string) => void;
  onHtmlChange?: (value: string) => void;
}

const EmailTemplateEditor = ({
  reactSourceCode,
  htmlTemplate,
  onReactCodeChange,
  onHtmlChange,
}: EmailTemplateEditorProps) => {
  const handleReactEditorWillMount = (monaco: typeof import('monaco-editor')) => {
    monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions({
      noSemanticValidation: true,
      noSyntaxValidation: true,
    });
  };

  const handleHtmlEditorWillMount = (monaco: typeof import('monaco-editor')) => {
    monaco.languages.html.htmlDefaults.setOptions({
      format: {
        contentUnformatted: 'pre,code,textarea',
        indentInnerHtml: true,
        preserveNewLines: true,
        endWithNewline: true,
        wrapLineLength: 120,
        unformatted: 'b,strong,i,span',
        tabSize: 0,
        insertSpaces: true,
        maxPreserveNewLines: undefined,
        indentHandlebars: true,
        extraLiners: '',
        wrapAttributes: 'auto',
      },
    });
  };

  const handleHtmlEditorDidMount: OnMount = (editor) => {
    if (editor) {
      editor.getAction('editor.action.formatDocument')?.run();
    }
  };

  const handleHtmlChange = (value: string | undefined) => {
    const newValue = value || '';
    onHtmlChange?.(newValue);
  };

  return (
    <TabView>
      <TabPanel header="React Code">
        <Editor
          height="calc(100vh - 400px)"
          theme="vs-dark"
          value={reactSourceCode}
          defaultLanguage="typescript"
          beforeMount={handleReactEditorWillMount}
          onChange={(value) => onReactCodeChange?.(value || '')}
        />
      </TabPanel>
      <TabPanel header="Html Code">
        <Editor
          height="calc(100vh - 400px)"
          theme="vs-dark"
          value={htmlTemplate}
          defaultLanguage="html"
          beforeMount={handleHtmlEditorWillMount}
          onMount={handleHtmlEditorDidMount}
          onChange={handleHtmlChange}
        />
      </TabPanel>
      <TabPanel header="Preview">
        <iframe
          id="previewIframe"
          title="previewIframe"
          srcDoc={htmlTemplate}
          style={{
            width: '100%',
            height: 'calc(100vh - 400px)',
            border: '1px solid #ccc',
          }}
        />
      </TabPanel>
    </TabView>
  );
};

export default EmailTemplateEditor;
